import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import lottieWeb from "lottie-web";
import { generateCloudinaryRawUrl } from "services/community/cloudinary-service";
import classnames from "classnames";
import { StyledLottieComponent } from "./lottie-component.scss";
class LottieComponent extends PureComponent {
    componentDidMount() {
        const { jsonPath, loop, autoplay, fireActionOnFrame } = this.props;
        this.animtaion = lottieWeb.loadAnimation({
            container: this._lottieDiv,
            renderer: "svg",
            loop,
            autoplay,
            path: generateCloudinaryRawUrl(jsonPath)
        });
        const { frame, action } = fireActionOnFrame;
        if (frame && action) {
            this.animtaion.onEnterFrame = this.fireActionIfReachedFrame;
        }
    }
    componentWillUnmount() {
        this.animtaion.onEnterFrame = null;
    }
    componentDidUpdate() {
        const { shouldPlay, reverseAnimation, shouldPause } = this.props;
        const animationDirection = reverseAnimation ? -1 : 1;
        this.animtaion.setDirection(animationDirection);
        shouldPlay && this.animtaion.play();
        shouldPause && this.animtaion.pause();
    }
    fireActionIfReachedFrame({ currentTime }) {
        const { reverseAnimation, fireActionOnFrame } = this.props;
        const { frame, action } = fireActionOnFrame;
        if (currentTime > frame && !reverseAnimation) {
            action();
        }
    }
    render() {
        const { aboveTheFold } = this.props;
        return /*#__PURE__*/ _jsx(StyledLottieComponent, {
            ref: (lottieDiv)=>this._lottieDiv = lottieDiv,
            className: classnames("lottie-component", {
                "above-the-fold": aboveTheFold
            })
        });
    }
    constructor(props){
        super(props);
        this.fireActionIfReachedFrame = this.fireActionIfReachedFrame.bind(this);
    }
}
export { LottieComponent as default };
LottieComponent.defaultProps = {
    jsonPath: "/static/lottie/arrow-swirl-down.json",
    autoplay: false,
    loop: false,
    fireActionOnFrame: {}
};
